import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "vh-100 standard-layout" }
const _hoisted_2 = { class: "border-right px-4" }
const _hoisted_3 = { class: "space-y-2" }
const _hoisted_4 = { class: "inline-flex justify-items-start" }
const _hoisted_5 = { class: "search-box" }
const _hoisted_6 = ["onKeyup"]
const _hoisted_7 = {
  key: 0,
  class: "dropdown-content",
  style: {"position":"absolute"}
}
const _hoisted_8 = { class: "inline-flex justify-items-start" }
const _hoisted_9 = { class: "search-box" }
const _hoisted_10 = ["onKeyup"]
const _hoisted_11 = { class: "search-box" }
const _hoisted_12 = ["onKeyup"]
const _hoisted_13 = { class: "date-filter" }
const _hoisted_14 = { class: "from-to flex gap-4" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "" }, " From ", -1)
const _hoisted_17 = ["onChange"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "" }, " To ", -1)
const _hoisted_19 = ["onChange"]
const _hoisted_20 = { class: "source space-x-4" }
const _hoisted_21 = { class: "space-x-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "" }, "Method", -1)
const _hoisted_23 = { class: "space-x-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "" }, "Source", -1)
const _hoisted_25 = { class: "row mt-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "mb-0" }, " Subject ")
], -1)
const _hoisted_27 = { class: "col-4 border bg-gray-50 overflow-y-scroll max-h-20 bg-white" }
const _hoisted_28 = { class: "row mt-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "mb-0" }, "Body")
], -1)
const _hoisted_30 = { class: "col-7 border bg-gray-50 overflow-y-scroll max-h-48 bg-white" }
const _hoisted_31 = { class: "row mt-2" }
const _hoisted_32 = {
  class: "col-9 d-flex justify-content-end mt-1",
  style: {"padding":"0px"}
}
const _hoisted_33 = {
  key: 0,
  class: "w-100 companies-list"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "small text-gray-500" }
const _hoisted_42 = { class: "small text-gray-500" }
const _hoisted_43 = { class: "small text-gray-500" }
const _hoisted_44 = { class: "small text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavigation = _resolveComponent("MainNavigation")!
  const _component_ClearButton = _resolveComponent("ClearButton")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_RenderHtml = _resolveComponent("RenderHtml")!
  const _component_ListView = _resolveComponent("ListView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MainNavigation, { folderId: null }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ListView, {
        filter: _ctx.filter,
        name: _ctx.name,
        showTitle: false,
        actions: _ctx.sentEmailsActions,
        resolveState: _ctx.resolveState,
        showEdit: _ctx.showEdit
      }, {
        filters: _withCtx(({ loadPage }) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "bg-gray p-2",
                  autocomplete: "off",
                  placeholder: "search",
                  ref: "search",
                  id: "search",
                  onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
                  onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                  onKeyup: loadPage
                }, null, 40, _hoisted_6), [
                  [_vModelText, _ctx.search]
                ]),
                (_ctx.dropdownOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("a", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addSearchTerm('To:')))
                      }, "To:"),
                      _createElementVNode("a", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addSearchTerm('From:')))
                      }, "From:"),
                      _createElementVNode("a", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addSearchTerm('Subject:')))
                      }, "Subject:"),
                      _createElementVNode("a", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addSearchTerm('WorkerReference:')))
                      }, "WorkerReference:")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "bg-gray p-2",
                    autocomplete: "off",
                    placeholder: "company name/number",
                    ref: "search",
                    id: "search",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.company) = $event)),
                    onKeyup: loadPage
                  }, null, 40, _hoisted_10), [
                    [_vModelText, _ctx.company]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "bg-gray p-2",
                    autocomplete: "off",
                    placeholder: "domain",
                    ref: "domain",
                    id: "domain",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.domain) = $event)),
                    onKeyup: loadPage
                  }, null, 40, _hoisted_12), [
                    [_vModelText, _ctx.domain]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    name: "from",
                    id: "from",
                    class: "p-2",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.from) = $event)),
                    onChange: loadPage
                  }, null, 40, _hoisted_17), [
                    [_vModelText, _ctx.from]
                  ]),
                  (!!_ctx.from)
                    ? (_openBlock(), _createBlock(_component_ClearButton, {
                        key: 0,
                        class: "ml-2",
                        onClick: ($event: any) => ((_ctx.from = null), loadPage())
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", null, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    name: "to",
                    id: "to",
                    class: "p-2",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.to) = $event)),
                    onChange: loadPage
                  }, null, 40, _hoisted_19), [
                    [_vModelText, _ctx.to]
                  ]),
                  (!!_ctx.to)
                    ? (_openBlock(), _createBlock(_component_ClearButton, {
                        key: 0,
                        class: "ml-2",
                        onClick: ($event: any) => ((_ctx.to = null), loadPage())
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_AutoComplete, {
                  modelValue: _ctx.method,
                  onItemSelect: ($event: any) => ((_ctx.method = $event.value), loadPage()),
                  suggestions: _ctx.methodKinds,
                  multiple: false,
                  autoHighlight: false,
                  delay: 0,
                  forceSelection: true,
                  dropdown: true,
                  completeOnFocus: true,
                  onComplete: _cache[11] || (_cache[11] = ($event: any) => (_ctx.searchMethods($event.query))),
                  field: "friendlyName"
                }, null, 8, ["modelValue", "onItemSelect", "suggestions"]),
                (!!_ctx.method)
                  ? (_openBlock(), _createBlock(_component_ClearButton, {
                      key: 0,
                      onClick: ($event: any) => ((_ctx.method = null), loadPage())
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_AutoComplete, {
                  modelValue: _ctx.source,
                  onItemSelect: ($event: any) => ((_ctx.source = $event.value), loadPage()),
                  suggestions: _ctx.sourceKinds,
                  multiple: false,
                  autoHighlight: false,
                  delay: 0,
                  forceSelection: true,
                  dropdown: true,
                  completeOnFocus: true,
                  onComplete: _cache[12] || (_cache[12] = ($event: any) => (_ctx.searchSources($event.query))),
                  field: "friendlyName"
                }, null, 8, ["modelValue", "onItemSelect", "suggestions"]),
                (!!_ctx.source)
                  ? (_openBlock(), _createBlock(_component_ClearButton, {
                      key: 0,
                      onClick: ($event: any) => ((_ctx.source = null), loadPage())
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.csv && _ctx.csv(...args)), ["prevent"]))
              }, " Export page to CSV ")
            ])
          ])
        ]),
        edit: _withCtx(({ selectedItem }) => [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_RenderHtml, {
                html: selectedItem.subject
              }, null, 8, ["html"])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_RenderHtml, {
                html: selectedItem.body
              }, null, 8, ["html"])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                class: "btn btn-danger",
                onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.setShowEdit(false)), ["prevent"]))
              }, " Close ")
            ])
          ])
        ]),
        list: _withCtx(({ selectedItem, items, setSelected, setSort, getItem }) => [
          (items.length > 0)
            ? (_openBlock(), _createElementBlock("table", _hoisted_33, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      class: "cursor-pointer",
                      onClick: _withModifiers(($event: any) => (setSort('ToString')), ["prevent"])
                    }, " To ", 8, _hoisted_34),
                    _createElementVNode("th", {
                      class: "cursor-pointer",
                      onClick: _withModifiers(($event: any) => (setSort('From')), ["prevent"])
                    }, " From ", 8, _hoisted_35),
                    _createElementVNode("th", {
                      class: "cursor-pointer",
                      onClick: _withModifiers(($event: any) => (setSort('DateSent')), ["prevent"])
                    }, " Date Sent ", 8, _hoisted_36),
                    _createElementVNode("th", {
                      class: "cursor-pointer",
                      onClick: _withModifiers(($event: any) => (setSort('Subject')), ["prevent"])
                    }, " Subject ", 8, _hoisted_37),
                    _createElementVNode("th", {
                      class: "cursor-pointer",
                      onClick: _withModifiers(($event: any) => (setSort('Method')), ["prevent"])
                    }, " Method ", 8, _hoisted_38),
                    _createElementVNode("th", {
                      class: "cursor-pointer",
                      onClick: _withModifiers(($event: any) => (setSort('Source')), ["prevent"])
                    }, " Source ", 8, _hoisted_39)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cast(items), (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: _normalizeClass(item.id == selectedItem?.id ? 'selected-row' : ''),
                      onClick: _withModifiers(($event: any) => (_ctx.getAndSetSentItem(setSelected, item.id, getItem), _ctx.setShowEdit(true)), ["prevent"])
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", null, _toDisplayString(item.toString), 1),
                        _createElementVNode("div", _hoisted_41, _toDisplayString(item.workerReference), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", null, _toDisplayString(item.from), 1),
                        _createElementVNode("div", _hoisted_42, _toDisplayString(item.companyName), 1),
                        _createElementVNode("div", _hoisted_43, _toDisplayString(item.companyNumber), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.dateService.formatDate(item.dateSent)), 1),
                        _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.dateService.formatTime(item.dateSent)), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.subject), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.enumService.getMethod(item.method)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.enumService.getSource(item.source)), 1)
                    ], 10, _hoisted_40))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["filter", "name", "actions", "resolveState", "showEdit"])
    ])
  ]))
}